<template>
  <div id="dashboard-abstract" v-if="abstract.data != null" v-loading="abstract.loading">

      <el-row :gutter="20">
        <el-col :span="6" v-for="(item, index) in abstract.data.cards" :key="index">
          <div class="data-card purple">
            <div class="card-info">
              <div class="title">
                <span>{{item.title}}</span>
              </div>
              <div class="value">
                <span>{{item.value}}</span>
              </div>
              <div class="description">
                <span>{{item.description}}</span>
              </div>
            </div>
            <div class="card-icon">
              <i :class="item.icon"></i>
            </div>
          </div>
        </el-col>
      </el-row>
      
      <div class="statistics-container">
        <div class="overview-table-header">
          <h3>{{$t('components.dashboard.summary')}}</h3>
          <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
            <el-button icon="fas fa-download" size="mini" @click="downloadReport"></el-button>
          </el-tooltip>
        </div>

        <el-row :gutter="20">
          <el-col :span="16">

            <el-table :data="abstract.data.abstractStatistics" style="width: 100%">
                <el-table-column label="" width="38">
                  <template slot-scope="scope">
                    <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('components.dashboard.abstract.notice')" min-width="180">
                  <template slot-scope="scope">
                    <span><b>{{ scope.row.title }}</b></span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('components.dashboard.abstract.accepted')" width="100">
                  <template slot-scope="scope">
                    <span><b>{{ scope.row.accepted }}</b></span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('components.dashboard.abstract.conditionally')" width="100">
                  <template slot-scope="scope">
                    <span><b>{{ scope.row.conditionallyAccepted }}</b></span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('components.dashboard.abstract.rejected')" width="100">
                  <template slot-scope="scope">
                    <span><b>{{ scope.row.rejected }}</b></span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('components.dashboard.abstract.waiting')" width="100">
                  <template slot-scope="scope">
                    <span><b>{{ scope.row.pending }}</b></span>
                  </template>
                </el-table-column>
              </el-table>

          </el-col>
          <el-col :span="8">
            <div class="pie-chart-container">
              <div ref="abstract-chart" id="abstract-chart" class="chart"></div>
            </div>
          </el-col>
        </el-row>
      </div>

  </div>
</template>

<script>

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { C } from "caniuse-lite/data/agents";

export default {
  components: {  },
  name: 'Abstract',
  data() {
    return {
      chart :null,
    };
  },
  methods: {
    downloadReport() {
      axios.post("report/generalstatistics", {}).then(res => {
        this.$message.success(res.data.alert.message)
      })
    },
    createPieChart(){
      var chart = am4core.create("abstract-chart", am4charts.PieChart);
      chart.data = this.abstract.data.chartData.datasets;
      chart.radius = am4core.percent(100);
      chart.hiddenState.properties.opacity = 0;
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "key";
      pieSeries.slices.template.propertyFields.fill = "color";
      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;
      chart.pieSeries = pieSeries;
      // chart.legend = new am4charts.Legend();
      // chart.legend.maxWidth = undefined;
      // chart.legend.valueLabels.template.align = "left";
      // chart.legend.valueLabels.template.textAlign = "end";
      chart.responsive.enabled = true;
      this.chart = chart;
    },
  },

  async mounted() {
    if(this.abstract.data == null)
    {
      await this.$store.dispatch('getAbstract', {});
      this.$nextTick(()=> {
        this.createPieChart();
      })
    } else {
      if (this.chart == null) {
        this.createPieChart();
      }
    }

    this.$watch('abstract.loading', function() {
      this.chart.data = this.abstract.data.chartData.datasets;
    });

  },

  computed: {
    abstract() {
      return this.$store.getters.getDashboardAbstract;
    },
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },

  watch: { },

};
</script>





// WEBPACK FOOTER //
// src/components/dashboard/Abstract.vue